const { isAfter }  = require('date-fns');

export default {

  chatMessages: ((state, getters, rootState) => (chatId) => {
    return Object.values(rootState.entities.chatMessages).filter(item => item.chat === chatId).sort((a, b) => {
      return isAfter(b.created, a.created) ? -1 : 1;
    });
  }),

  
  filter: ((state) => (compId) => {
    return state.filters[compId];
  }),

  chatFilterDialog: ((state) => (compId) => {
    return state.chatFilterDialogs[compId]
  }),

  showScrollToNewMessagesButton: (state) => { return state.showScrollToNewMessagesButton },
  newMessagesCount: state => state.newMessagesCount,

};


// WEBPACK FOOTER //
// ./src/store/chats/getters.js